const initialState = {
    addcontry: [],
    data:[],
    updatedata:[],
    remove:[]
  };
  
  const ACountryReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_DATA_SUCCESS':
            return { ...state, data: action.payload };
      case 'FETCH_Addcountry_SUCCESS':
        return { ...state, addcontry: action.payload };
        case 'FETCH_Update_SUCCESS':
        return { ...state, updatedata: action.payload };
        case 'FETCH_Remove_SUCCESS':
        return { ...state, remove: action.payload };


      default:
        return state;
    }
  };
  
  export default ACountryReducers;
  
  